<div class="admin-section-header" [class.collapsed]="onHoldCollapsedInternal">
  <div
    [class.collapsed]="onHoldCollapsedInternal"
    class="d-flex"
    (click)="onHoldCollapsedInternal = !onHoldCollapsedInternal"
  >
    <div>
      On hold
    </div>
    <div class="admin-section-arrow">
      <div>
        <button mat-icon-button>
          <mat-icon class="admin-section-arrow-icon">arrow_drop_up</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
<div [collapse]="onHoldCollapsedInternal" [isAnimated]="!safari">
  <div class="collapse-content-container">
    <client-sub-project-on-hold-content
      [subProject]="subProject"
      (save)="save.emit()"
    ></client-sub-project-on-hold-content>
  </div>
</div>
